// extracted by mini-css-extract-plugin
export default {"container":"rs-z","brandName":"ss-z","productName":"ts-z","productNamePdpEnhancements":"us-z","breakLongProductName":"vs-z"};